const LANG = 'nb'
const LOCALE = 'nb'

// ? ******************************************************************************************
// ? ******************************************************************************************

const BRANDS = {
  ZMARTA: {
    ID: 2,
    BROKER_ID: -8,
    NAME: 'Zmarta',
    URL: 'https://www.zmarta.no',
    USER_AGREEMENT_URL: '/avtale/fordelsavtale',
    APP_TERMS_URL: '/avtale/privatlan',
    REQUIREMENT_EMAIL: 'info@zmarta.no',
    PHONE: '23 96 70 10'
  },
  BROKER: {
    ID: 1,
    BROKER_ID: -5,
    NAME: 'Centum',
    URL: 'https://www.centum.no',
    USER_AGREEMENT_URL: '/avtale/fordelsavtale',
    APP_TERMS_URL: '/avtale/privatlan',
    REQUIREMENT_EMAIL: 'info@centum.no',
    PHONE: '23 96 70 00'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const MY_ACCOUNT = {
  BASE: {
    NB: '/mine-soknader',
    EN: '/en/my-pages'
  },
  PRODUCT: {
    NB: '/forbrukslan',
    EN: '/consumer-loan'
  },
  OFFERS: {
    NB: '/tilbud',
    EN: '/offers'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const AMOUNT_OF_LENDERS = 20

// ? ******************************************************************************************
// ? ******************************************************************************************

const AGE = {
  MAX: 100,
  MIN: 20
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const LOAN_AMOUNT = {
  MIN: 5000,
  MAX: 800000,
  STEP: 5000,
  DEFAULT: 150000,
  LEGAL_TEXT: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DURATION = {
  MIN: 1,
  MAX: 20,
  STEP: 1,
  DEFAULT: 5,
  LEGAL_TEXT: 'Nedbetalingstid 1-5 år. Dersom du skal bruke lånet til å innfri annen gjeld kan nedbetalingstid lengre enn 5 år tilbys, 1-20 år.'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const LOAN_AMOUNT_REFINANCE = {
  MIN: 5000,
  MAX: 600000,
  STEP: 5000,
  DEFAULT: 250000,
  LEGAL_TEXT: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DURATION_REFINANCE = {
  MIN: 1,
  MAX: 20,
  STEP: 1,
  DEFAULT: 8,
  LEGAL_TEXT: 'Nedbetalingstid 1-5 år. Dersom du skal bruke lånet til å innfri annen gjeld kan nedbetalingstid lengre enn 5 år tilbys, 1-20 år.'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PHONE_NO_GROUPING = {
  MIN_LENGTH: 8,
  REGEX: /(\d{3})(\d{2})(\d{3})/,
  OUTPUT: '$1 $2 $3'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const ZOPIM = {
  ZMARTA: '2zwWDmdbWpDAKre8CwWVq4ZRMrQx9k8U',
  BROKER: '2zwXaV0EgqPqwAGG54v988cAPiHKIAnW'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const TIME_BASED_EMPLOYMENT = [3, 5]

// ? ******************************************************************************************
// ? ******************************************************************************************

const HAS_EMPLOYMENT = [1, 2, 3, 4, 5, 10]

// ? ******************************************************************************************
// ? ******************************************************************************************

const HAS_PARTNER = [1, 3]

// ? ******************************************************************************************
// ? ******************************************************************************************

const EXPERIMENT_EVENT_IDS = {
  LOAN_APPLICATION_DECLINED: {
    ZMARTA: 18817093613,
    BROKER: null
  },
  LOAN_APPLICATION_DUPLICATE: {
    ZMARTA: 18832420766,
    BROKER: null
  },
  LOAN_APPLICATION_USABLE: {
    ZMARTA: 18811194545,
    BROKER: null
  },
  LOAN_APPLICATION_FULL: {
    ZMARTA: 18790923908,
    BROKER: null
  },
  LOAN_APPLICATION_USABLE_CO_APPLICANT: {
    ZMARTA: 22625972174,
    BROKER: null
  },
  LOAN_APPLICATION_FULL_CO_APPLICANT: {
    ZMARTA: 22600831926,
    BROKER: null
  },
  LOAN_MYPAGES_READMORE: {
    ZMARTA: 18817045826,
    BROKER: null
  },
  LOAN_MYPAGES_SELECT: {
    ZMARTA: 18834220567,
    BROKER: null
  },
  LOAN_MYPAGES_SELECTED: {
    ZMARTA: 22635501125,
    BROKER: null
  },
  LOAN_MYPAGES_SIGNINGLINK: {
    ZMARTA: 18800464307,
    BROKER: null
  },
  LOAN_MYPAGES_REFINANCE_CONFIRM: {
    ZMARTA: 21511711035,
    BROKER: 21485661852
  },
  LOAN_MYPAGES_REFINANCE_DECLINE: {
    ZMARTA: 21513700501,
    BROKER: 21498000905
  },
  LOAN_MYPAGES_SELECT_EID_LOGIN: {
    ZMARTA: 22520440348,
    BROKER: 22559260360
  },
  LOAN_APPLICATION_PREFILL_DATA: {
    ZMARTA: 23609990004,
    BROKER: 23500121692
  },
  LOAN_APPLICATION_REAPPLY: {
    ZMARTA: 23509011955,
    BROKER: 23614940209
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PRODUCT_SLUGS = {
  PRIVATE_LOAN: '/forbrukslaan',
  REFINANCE_LOAN: '/refinansiering',
  CAR_LOAN: '/billan'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const SSNS = {
  DECLINED: '01017202746',
  CF: '01017202908'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const FIELDS_THAT_ALLOW_0 = [
  'children',
  'monthlyIncome'
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const CURRENCY = {
  nb: {
    currency: 'kr',
    format: '{amount} {currency}'
  },
  en: {
    currency: 'NOK',
    format: '{currency} {amount}'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const NUMBERS = {
  nb: {
    thousandSeparator: ' ',
    decimalSign: ','
  },
  en: {
    thousandSeparator: ',',
    decimalSign: '.'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const RATE = '%'

// ? ******************************************************************************************
// ? ******************************************************************************************

const GOOGLE_ANALYTICS = {
  NAME: {
    ZMARTA: 'owned',
    BROKER: 'centum'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const BANKS = {}

// ? ******************************************************************************************
// ? ******************************************************************************************

const FIVE_DIGIT_CLEARING_NO = []

// ? ******************************************************************************************
// ? ******************************************************************************************

const ALTERNATE_INTEREST_RATE_LIMIT = 0

// ? ******************************************************************************************
// ? ******************************************************************************************

const URLS = {
  ZMARTA: {
    APPLICATION: '/lane-penger/forbrukslan/soknad',
    CONTINUE_APPLICATION: '/lane-penger/forbrukslan/fortsett-soknad',
    ADD_CO_APPLICANT: '/lane-penger/forbrukslan/legg-til-medsoker'
  },
  BROKER: {
    APPLICATION: '/forbrukslan/soknad',
    CONTINUE_APPLICATION: '/forbrukslan/fortsett-soknad',
    ADD_CO_APPLICANT: '/forbrukslan/legg-til-medsoker'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const REQUIREMENTS = {}
// ? ******************************************************************************************
// ? ******************************************************************************************

const PAYOUT_SPAN = ''

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_DEFAULTS = {
  carLoan: 3,
  chargeCard: 244,
  creditCard: 106,
  mortgage: 1,
  otherLoan: 6,
  studentLoan: 2
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_REGISTRY_MAP = {
  loan: {
    971049944: 5, // Skandinaviska Enskilda Banken
    937897286: 7, // Voss Sparebank
    915691161: 8, // Sandnes Sparebanken
    937897464: 10, // Etne sparebank
    937898614: 11, // Luster sparebank
    971171324: 15, // HANDELSBANKEN
    958422830: 19, // INTRUM CAPITAL AS
    923194592: 27, // BB - TF BANK NORGE
    984150865: 34, // Resurs Bank AB
    911745267: 38, // Collector Bank AB
    983521592: 39, // Santander Consumer Bank AS
    984851006: 41, // DNB Bank ASA
    991455671: 42, // Bank Norwegian
    924507500: 44, // Nordea Finans Norge As
    916573154: 46, // Nordax Bank AB
    993417262: 47, // IKANO BANK SE, NORGESFILIALEN
    995568217: 48, // Gjensidige Forsikring ASA
    944521836: 56, // Sparebank 1 Sørøst - Norge
    930050237: 57, // Sparebank 1 Finans Nord-Norge
    952706365: 57, // SPAREBANK 1 NORD - NORGE
    986346422: 59, // Svea Finans Trondheim
    816914582: 71, // INSTABANK ASA
    998997801: 73, // Komplett Bank ASA
    990728488: 74, // AVIDA FINANS AB NUF
    916012683: 77, // MYBANK ASA
    997536320: 79, // Thorn Norge Finans AS
    995515164: 90, // Klarna Norge AS
    920610145: 91, // Ferratum
    986144706: 109, // BraBank ASA
    990323429: 110, // Nordea Direct Bank ASA
    977074010: 111, // Danske Bank
    985675279: 112, // Alektum Finans AS
    911629283: 113, // As Financiering
    917983747: 114, // AXACTOR Capital AS
    995610760: 115, // Brage Finans AS
    914766451: 116, // CIRCLE K NORGE AS
    989997254: 117, // Eika Kredittbank AS
    991682511: 118, // Ekspress Bank
    990892040: 119, // Folkefinans AS
    971227222: 120, // Nordea Eiendomskreditt AS
    920058817: 121, // Nordea Bank AB(publ)Filial N
    '0007:5561978825': 122, // AK NORDIC AB
    984467990: 123, // Kredinor Finans AS
    914864445: 124, // BNbank ASA, Personmarked
    939944354: 125, // Indre Østfold og Andebu Gjensidig brannkasse
    987664398: 126, // Nordea Finance Equpment AS
    940468671: 127, // Flekkefjord kommunale pensjonskasse
    953299216: 128, // Storebrand Bank ASA
    990645515: 129, // Storebrand Boligkreditt
    979988184: 130, // Skien kommunale pensjonskasse
    940017211: 131, // Sandefjord komm. Pensjonskasse
    919628103: 132, // Modhi Finance AS
    925154407: 133, // Northmill Bank AB
    987277289: 134, // TELIA FINANCE NORGE
    818698712: 135, // Payex Sverige AB
    995262584: 136, // PRA Group Norge AS
    816793432: 137, // Tolga - Os Sparebank
    837886252: 138, // Blaker Sparebank
    837900212: 139, // Ørskog Sparebank
    837902622: 140, // Haltdalen Sparebank
    977041244: 141, // CULTURA BANK
    982719445: 142, // Jernbanepers.Sparebank
    985750378: 143, // Fornebu Sparebank
    988257133: 144, // Bank2 ASA
    991853995: 145, // Sparebanken Bien juridisk
    993153036: 146, // SSB Boligkredit AS
    995883422: 147, // Totens Sparebank Boligkreditt
    937893299: 148, // Hjartdal og Gransherad Spareba
    937893833: 149, // Birkenes Sparebank
    937893922: 150, // Valle Sparebank
    937894082: 151, // Arendal og Omegns Sparebank
    937894171: 152, // Evje og Hornnes Sparebank
    937894260: 153, // Østre Agder Sparebank
    937895976: 154, // Jæren Sparebank
    937896581: 155, // Hjelmeland Sparebank
    937897375: 156, // Tysnes Sparebank
    937899963: 157, // Sunndal Sparebank
    937900775: 158, // Romsdal Sparebank
    937900953: 159, // Rindal Sparebank Avd.Hovedkon
    937901291: 160, // Melhus Sparebank
    937901569: 161, // Oppdals Sparebank
    937901836: 162, // Selbu Sparebank
    937901925: 163, // Ørland Sparebank
    937902085: 164, // Bjugn Sparebank
    937902174: 165, // Sparebanken Hemne
    817244742: 166, // Voss Veksel-og Landmandsbank
    837889812: 167, // Skue Sparebank
    837897912: 168, // INDRE SOGN SPAREBANK
    937884672: 169, // Marker Sparebank
    937885199: 170, // Askim Sparebank
    937885288: 171, // Berg Sparebank
    937885911: 172, // Lillestrøm Sparebank
    937887787: 173, // Totens Sparebank
    937890540: 174, // Andebu Sparebank
    937894805: 175, // Kvinesdal Sparebank
    917850984: 176, // Næringsbanken ASA
    927016966: 177, // Facit Bank
    937884494: 178, // Eidsberg Sparebank
    937885377: 179, // Trøgstad Sparebank
    937885644: 180, // AURSKOG SPAREBANK
    937885822: 181, // Høland og Setskog Sparebank
    937886160: 182, // Strømmen Sparebank
    937886705: 183, // Grue Sparebank
    937887043: 184, // ODAL SPAREBANK
    937888570: 185, // Etnedal Sparebank
    937888759: 186, // Valdres Sparebank
    937890729: 187, // LARVIKBANKEN
    937891245: 188, // Skagerrak Sparebank
    937891423: 189, // Tinn Sparebank
    937891512: 190, // Sparebanken Din
    937891601: 191, // Drangedal Sparebank
    937902263: 192, // Soknedal Sparebank
    937902352: 193, // Stadsbygd Sparebank
    937902441: 194, // Åfjord Sparebank
    937902719: 195, // Nidaros Sparebank
    937903146: 196, // Grong Sparebank
    937903235: 197, // Hegra Sparebank
    937903502: 198, // Aasen Sparebank
    937903979: 199, // Narvik Sparebank
    937904673: 200, // Gildeskål sparebank
    937905378: 201, // SPAREBANK 68 GRADER NORD
    947278770: 202, // Orkla Sparebank
    956548888: 203, // RørosBanken
    958995369: 204, // Storebrand Livsforsikring As
    920232701: 205, // NORDIC CORPORATE BANK ASA
    993245887: 206, // Sergel Finans AS
    997706188: 207, // MARGINALEN BANK BANKATIEBOLAG
    938521549: 208, // Sparebank 1 Finans Midt-Norge
    975963748: 209, // Sparebank 1 Finans Østlandet
    916651783: 210, // ST1 Nordic OY
    832554332: 211, // Sparebanken Vest
    937889631: 212, // Sparebank 1 Hallingdal Avd Gol
    990906475: 213, // Pareto Bank ASA
    937889275: 214, // SpareBank 1 Ringerike Hadeland
    937889186: 215, // SpareBank 1 Modum
    937888937: 216, // Sparebanken Øst
    918315446: 217, // Kraft Bank ASA
    937888104: 218, // Sparebank 1 Gudbrandsdalen
    937888015: 219, // SpareBank 1 Lom og Sjåk
    920428959: 220, // NorgesGruppen Finans AS
    920426530: 221, // Sparebank 1 Østlandet
    915287700: 222, // Sbanken ASA
    913953517: 223, // Lowell Finans AS
    837895502: 224, // Haugesund sparebank
    837884942: 225, // SpareBank 1 Østfold Akershus
    937894627: 226, // Flekkefjord Sparebank
    937894538: 227, // Sparebanken Sør
    937893655: 228, // Lillesands sparebank
    937895321: 229, // Sparebank 1 SR - Bank ASA
    911986884: 230, // OBOSBANKEN AS
    937896670: 231, // Skudenes og Aakra sparebank
    980374181: 232, // Landkreditt Bank AS
    937904029: 233, // Sparebank 1 Helgeland
    993821837: 234, // KLP Banken AS
    937901003: 235, // SpareBank 1 SMN
    937899785: 236, // Sparebank 1 Søre Sunnmøre
    937899408: 237, // SpareBank 1 Nordøre
    937899319: 238, // Sparebanken Møre
    937895054: 239, // SØGNE OG GREIPSTAD SPB.
    937894716: 240, // SPARESKILLINGSBANKEN
    937896859: 241, // Fana Sparebank
    946670081: 242, // Sparebanken Sogn og Fjordane
    978690920: 243 // Toyota Kreditbank Gmbk
  },
  credit: {
    919061545: 45, // Entercard Norge
    885621252: 67, // Eika Boligkreditt AS
    975966453: 83, // Sparebank 1 Kredittkort AS
    982793386: 84, // SEB Kort Bank AB Oslofilialen
    920854346: 88, // American Express Europe S.A (N
    994210130: 100, // Arvato Finance AS
    '0007:5569622441': 105, // QLIRO AB
    985675279: 245, // Alektum Finans AS
    911629283: 246, // As Financiering
    917983747: 247, // AXACTOR Capital AS
    995610760: 248, // Brage Finans AS
    914766451: 249, // CIRCLE K NORGE AS
    989997254: 250, // Eika Kredittbank AS
    991682511: 251, // Ekspress Bank
    990892040: 252, // Folkefinans AS
    971227222: 253, // Nordea Eiendomskreditt AS
    920058817: 254, // Nordea Bank AB(publ)Filial N
    '0007:5561978825': 255, // AK NORDIC AB
    984467990: 256, // Kredinor Finans AS
    914864445: 257, // BNbank ASA, Personmarked
    939944354: 258, // Indre Østfold og Andebu Gjensidig brannkasse
    987664398: 259, // Nordea Finance Equpment AS
    940468671: 260, // Flekkefjord kommunale pensjonskasse
    953299216: 261, // Storebrand Bank ASA
    990645515: 262, // Storebrand Boligkreditt
    979988184: 263, // Skien kommunale pensjonskasse
    940017211: 264, // Sandefjord komm. Pensjonskasse
    919628103: 265, // Modhi Finance AS
    925154407: 266, // Northmill Bank AB
    987277289: 267, // TELIA FINANCE NORGE
    818698712: 268, // Payex Sverige AB
    995262584: 269, // PRA Group Norge AS
    816793432: 270, // Tolga - Os Sparebank
    837886252: 271, // Blaker Sparebank
    837900212: 272, // Ørskog Sparebank
    837902622: 273, // Haltdalen Sparebank
    977041244: 274, // CULTURA BANK
    982719445: 275, // Jernbanepers.Sparebank
    985750378: 276, // Fornebu Sparebank
    988257133: 277, // Bank2 ASA
    991853995: 278, // Sparebanken Bien juridisk
    993153036: 279, // SSB Boligkredit AS
    995883422: 280, // Totens Sparebank Boligkreditt
    937893299: 281, // Hjartdal og Gransherad Spareba
    937893833: 282, // Birkenes Sparebank
    937893922: 283, // Valle Sparebank
    937894082: 284, // Arendal og Omegns Sparebank
    937894171: 285, // Evje og Hornnes Sparebank
    937894260: 286, // Østre Agder Sparebank
    937895976: 287, // Jæren Sparebank
    937896581: 288, // Hjelmeland Sparebank
    937897375: 289, // Tysnes Sparebank
    937899963: 290, // Sunndal Sparebank
    937900775: 291, // Romsdal Sparebank
    937900953: 292, // Rindal Sparebank Avd.Hovedkon
    937901291: 293, // Melhus Sparebank
    937901569: 294, // Oppdals Sparebank
    937901836: 295, // Selbu Sparebank
    937901925: 296, // Ørland Sparebank
    937902085: 297, // Bjugn Sparebank
    937902174: 298, // Sparebanken Hemne
    817244742: 299, // Voss Veksel-og Landmandsbank
    837889812: 300, // Skue Sparebank
    837897912: 301, // INDRE SOGN SPAREBANK
    937884672: 302, // Marker Sparebank
    937885199: 303, // Askim Sparebank
    937885288: 304, // Berg Sparebank
    937885911: 305, // Lillestrøm Sparebank
    937887787: 306, // Totens Sparebank
    937890540: 307, // Andebu Sparebank
    937894805: 308, // Kvinesdal Sparebank
    917850984: 309, // Næringsbanken ASA
    927016966: 310, // Facit Bank
    937884494: 311, // Eidsberg Sparebank
    937885377: 312, // Trøgstad Sparebank
    937885644: 313, // AURSKOG SPAREBANK
    937885822: 314, // Høland og Setskog Sparebank
    937886160: 315, // Strømmen Sparebank
    937886705: 316, // Grue Sparebank
    937887043: 317, // ODAL SPAREBANK
    937888570: 318, // Etnedal Sparebank
    937888759: 319, // Valdres Sparebank
    937890729: 320, // LARVIKBANKEN
    937891245: 321, // Skagerrak Sparebank
    937891423: 322, // Tinn Sparebank
    937891512: 323, // Sparebanken Din
    937891601: 324, // Drangedal Sparebank
    937902263: 325, // Soknedal Sparebank
    937902352: 326, // Stadsbygd Sparebank
    937902441: 327, // Åfjord Sparebank
    937902719: 328, // Nidaros Sparebank
    937903146: 329, // Grong Sparebank
    937903235: 330, // Hegra Sparebank
    937903502: 331, // Aasen Sparebank
    937903979: 332, // Narvik Sparebank
    937904673: 333, // Gildeskål sparebank
    937905378: 334, // SPAREBANK 68 GRADER NORD
    947278770: 335, // Orkla Sparebank
    956548888: 336, // RørosBanken
    958995369: 337, // Storebrand Livsforsikring As
    920232701: 338, // NORDIC CORPORATE BANK ASA
    993245887: 339, // Sergel Finans AS
    997706188: 340, // MARGINALEN BANK BANKATIEBOLAG
    938521549: 341, // Sparebank 1 Finans Midt-Norge
    975963748: 342, // Sparebank 1 Finans Østlandet
    916651783: 343, // ST1 Nordic OY
    832554332: 344, // Sparebanken Vest
    937889631: 345, // Sparebank 1 Hallingdal Avd Gol
    990906475: 346, // Pareto Bank ASA
    937889275: 347, // SpareBank 1 Ringerike Hadeland
    937889186: 348, // SpareBank 1 Modum
    937888937: 349, // Sparebanken Øst
    918315446: 350, // Kraft Bank ASA
    937888104: 351, // Sparebank 1 Gudbrandsdalen
    937888015: 352, // SpareBank 1 Lom og Sjåk
    920428959: 353, // NorgesGruppen Finans AS
    920426530: 354, // Sparebank 1 Østlandet
    915287700: 355, // Sbanken ASA
    913953517: 356, // Lowell Finans AS
    837895502: 357, // Haugesund sparebank
    837884942: 358, // SpareBank 1 Østfold Akershus
    937894627: 359, // Flekkefjord Sparebank
    937894538: 360, // Sparebanken Sør
    937893655: 361, // Lillesands sparebank
    937895321: 362, // Sparebank 1 SR - Bank ASA
    911986884: 363, // OBOSBANKEN AS
    937896670: 364, // Skudenes og Aakra sparebank
    980374181: 365, // Landkreditt Bank AS
    937904029: 366, // Sparebank 1 Helgeland
    993821837: 367, // KLP Banken AS
    937901003: 368, // SpareBank 1 SMN
    937899785: 369, // Sparebank 1 Søre Sunnmøre
    937899408: 370, // SpareBank 1 Nordøre
    937899319: 371, // Sparebanken Møre
    937895054: 372, // SØGNE OG GREIPSTAD SPB.
    937894716: 373, // SPARESKILLINGSBANKEN
    937896859: 374, // Fana Sparebank
    946670081: 375, // Sparebanken Sogn og Fjordane
    978690920: 376, // Toyota Kreditbank Gmbk
    984851006: 377, // DNB Bank ASA
    816914582: 378, // INSTABANK ASA
    995515164: 379, // Klarna Norge AS
    971049944: 380, // Skandinaviska Enskilda Banken
    937897286: 381, // Voss Sparebank
    915691161: 382, // Sandnes Sparebanken
    937897464: 383, // Etne sparebank
    937898614: 384, // Luster sparebank
    971171324: 385, // HANDELSBANKEN
    958422830: 386, // INTRUM CAPITAL AS
    923194592: 387, // BB - TF BANK NORGE
    984150865: 388, // Resurs Bank AB
    911745267: 389, // Collector Bank AB
    983521592: 390, // Santander Consumer Bank AS
    991455671: 391, // Bank Norwegian
    924507500: 392, // Nordea Finans Norge As
    916573154: 393, // Nordax Bank AB
    993417262: 394, // IKANO BANK SE, NORGESFILIALEN
    995568217: 395, // Gjensidige Forsikring ASA
    986346422: 396, // Svea Finans Trondheim
    998997801: 397, // Komplett Bank ASA
    990728488: 398, // AVIDA FINANS AB NUF
    916012683: 399, // MYBANK ASA
    997536320: 400, // Thorn Norge Finans AS
    920610145: 401, // Ferratum
    986144706: 402, // BraBank ASA
    990323429: 403, // Nordea Direct Bank ASA
    977074010: 404 // Danske Bank
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const HIDE_OPTIONS = {
  socialEconomicStatus: [],
  residenceType: [],
  residenceOwnershipType: [4],
  otherLoanType: []
}

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  LANG,
  LOCALE,
  BRANDS,
  MY_ACCOUNT,
  AMOUNT_OF_LENDERS,
  AGE,
  LOAN_AMOUNT,
  DURATION,
  LOAN_AMOUNT_REFINANCE,
  DURATION_REFINANCE,
  PHONE_NO_GROUPING,
  ZOPIM,
  TIME_BASED_EMPLOYMENT,
  HAS_EMPLOYMENT,
  HAS_PARTNER,
  EXPERIMENT_EVENT_IDS,
  PRODUCT_SLUGS,
  SSNS,
  FIELDS_THAT_ALLOW_0,
  CURRENCY,
  NUMBERS,
  GOOGLE_ANALYTICS,
  BANKS,
  FIVE_DIGIT_CLEARING_NO,
  ALTERNATE_INTEREST_RATE_LIMIT,
  URLS,
  REQUIREMENTS,
  RATE,
  PAYOUT_SPAN,
  DEBT_DEFAULTS,
  DEBT_REGISTRY_MAP,
  HIDE_OPTIONS
}
